<template>
  <div class="main-body">
    <header class="app-header">
      <div class="header-wrapper">
        <div class="logo-wrapper">
          智慧教育综合管理平台
        </div>
        <div class="personal-wrapper">
          <img class="user-icon" src="../../assets/img/user_icon.png">
          <span class="user-label">账户</span>
        </div>
      </div>
    </header>
    <main class="layout-main">
      <div class="layout-wrapper">
        <div class="sys-item">
          <img class="sys-icon" src="../../assets/img/schoolShield_icon.png">
          <span class="sys-label">校盾系统</span>
        </div>
        <div class="sys-item">
          <img class="sys-icon" src="../../assets/img/safeManage_icon.png">
          <span class="sys-label">平安校园</span>
        </div>
        <div class="sys-item">
          <img class="sys-icon" src="../../assets/img/kitchenware_icon.png">
          <span class="sys-label">明厨亮灶</span>
        </div>
        <div class="sys-item">
          <img class="sys-icon" src="../../assets/img/safeManage_icon.png">
          <span class="sys-label">校园安全管理</span>
        </div>
      </div>
    </main>
    <footer class="footer">
      <!-- Copyright 2019 | 湖南新云网科技有限公司 | 湘ICP备18015340号-2 | 客服热线0731-84457797 | 版本号：v3.0.0 -->
    </footer>
  </div>
</template>

<script>
export default {
  name: 'ErrorLog',
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.main-body {
  background: #f0f2f5;
  height: 100vh;
  .app-headerv{
    max-height: 62px;
    color: #fff;
    border-bottom: 2px solid #007afc;
    background: #007afc;
  }
  .header-wrapper,.layout-main,.footer {
    margin: 0 auto;
    width: 1200px;
  }
  header {
    width: 100%;
    height: 100px;
    background: #007AFC;
    color: #FFFFFF;
    .logo-wrapper{
      font-size: 33px;
      float: left;
      line-height: 100px;
    }
    .personal-wrapper {
      float: right;
      display: flex;
      flex-direction: column;
      height: 100px;
      justify-content: center;
      text-align: center;
    }
    .user-label {
      padding-top: 7px;
    }
  }
  .layout-main {
    .sys-item {
      width: 188px;
      height: 192px;
      background-color: #FFFFFF;
      margin-right: 60px;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .layout-wrapper {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: 83px;
    }
    .sys-icon {
      width: 100px;
      height: 100px;
      background-repeat: no-repeat;
      background-size: 100%;
    }
    .sys-label{
      padding-top: 16px;
    }

  }
  .footer {
    color: #999999;
    padding-bottom: 58px;
    position: fixed;
    bottom: 0px;
    width: 100%;
    text-align: center;
  }
}
</style>
